import { render, staticRenderFns } from "./BiddingDescription.vue?vue&type=template&id=aed759d2&scoped=true&"
import script from "./BiddingDescription.vue?vue&type=script&lang=js&"
export * from "./BiddingDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed759d2",
  null
  
)

export default component.exports